<template>
  <a-modal
    :visible="visible"
    title="视频监控"
    width="80vw"
    :footer="null"
    :destroyOnClose="true"
    @cancel="handleClose"
  >
    <div class="cctv-container">
      <div class="cctv-header">
        <div class="header-left">
          <div class="mode-buttons">
            <a-button 
              :type="viewMode === 'mode1x1' ? 'primary' : 'default'" 
              @click="changeViewMode('mode1x1')"
            >单屏</a-button>
            <a-button 
              :type="viewMode === 'mode2x2' ? 'primary' : 'default'" 
              @click="changeViewMode('mode2x2')"
            >四分屏</a-button>
            <a-button 
              :type="viewMode === 'mode3x3' ? 'primary' : 'default'" 
              @click="changeViewMode('mode3x3')"
            >九分屏</a-button>
          </div>
        </div>
        <div class="header-right">
          <a-select
            v-model:value="selectedCamera"
            style="width: 200px"
            placeholder="选择摄像头"
            @change="handleCameraChange"
          >
            <a-select-option v-for="camera in cameras" :key="camera.id" :value="camera.id">
              {{ camera.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div :class="['cctv-content', viewMode]">
        <div 
          v-for="n in getScreenNumber" 
          :key="n" 
          class="video-screen" 
          :class="{ active: n === activeScreen }"
          @click="setActiveScreen(n)"
        >
          <div v-if="screenData[n-1]" class="video-info">
            <div class="camera-name">{{ screenData[n-1].name }}</div>
            <div class="camera-status" :class="screenData[n-1].status">
              {{ screenData[n-1].status === 'online' ? '在线' : '离线' }}
            </div>
          </div>
          <div class="video-placeholder" v-if="!screenData[n-1]">
            <a-icon type="video-camera" />
            <p>点击选择摄像头</p>
          </div>
          <video v-if="screenData[n-1]" class="video-player" controls autoplay muted loop>
            <source :src="screenData[n-1].url" type="video/mp4">
            您的浏览器不支持视频播放
          </video>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'CCTV',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      viewMode: 'mode2x2',
      selectedCamera: undefined,
      activeScreen: 1,
      screenData: [],
      cameras: [
        { id: 'CAM-001', name: '监控点A', status: 'online', url: '/zssqf.mp4' },
        { id: 'CAM-002', name: '监控点B', status: 'online', url: '/zssqf.mp4' },
        { id: 'CAM-003', name: '监控点C', status: 'offline', url: '/zssqf.mp4' },
        { id: 'CAM-004', name: '监控点D', status: 'online', url: '/zssqf.mp4' },
        { id: 'CAM-005', name: '监控点E', status: 'online', url: '/zssqf.mp4'},
        { id: 'CAM-006', name: '监控点F', status: 'offline', url: '/zssqf.mp4'},
        { id: 'CAM-007', name: '监控点G', status: 'online', url: '/zssqf.mp4' },
        { id: 'CAM-008', name: '监控点H', status: 'online', url: '/zssqf.mp4' },
        { id: 'CAM-009', name: '监控点I', status: 'online', url: '/zssqf.mp4' },
        { id: 'CAM-010', name: '监控点J', status: 'offline', url: '/zssqf.mp4' }
      ]
    }
  },
  computed: {
    getScreenNumber() {
      const mode = this.viewMode
      if (mode === 'mode1x1') return 1
      if (mode === 'mode2x2') return 4
      if (mode === 'mode3x3') return 9
      return 4
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    setActiveScreen(screenNumber) {
      this.activeScreen = screenNumber
    },
    changeViewMode(mode) {
      console.log('Changing view mode to:', mode)
      if (this.viewMode !== mode) {
        this.viewMode = mode
        this.updateScreenData()
      }
    },
    handleViewModeChange(e) {
      console.log('View mode changed to:', this.viewMode)
      this.updateScreenData()
    },
    updateScreenData() {
      const newScreenCount = this.getScreenNumber
      console.log('New screen count:', newScreenCount)
      
      // 创建新数组
      let newScreenData = [...this.screenData]
      
      // 如果数组长度不够，确保它有足够的长度
      while (newScreenData.length < newScreenCount) {
        newScreenData.push(null)
      }
      
      // 如果数组太长，截断它
      if (newScreenData.length > newScreenCount) {
        newScreenData = newScreenData.slice(0, newScreenCount)
      }
      
      this.screenData = newScreenData
      
      // 确保活动屏幕在有效范围内
      if (this.activeScreen > newScreenCount) {
        this.activeScreen = 1
      }
    },
    handleCameraChange(cameraId) {
      const camera = this.cameras.find(c => c.id === cameraId)
      if (camera && this.activeScreen <= this.getScreenNumber) {
        // Vue 3 方式直接修改数组
        const newScreenData = [...this.screenData]
        newScreenData[this.activeScreen - 1] = camera
        this.screenData = newScreenData
        
        // 自动移动到下一个空闲屏幕
        let nextScreenFound = false
        for (let i = this.activeScreen; i < this.getScreenNumber; i++) {
          if (!this.screenData[i]) {
            this.activeScreen = i + 1
            nextScreenFound = true
            break
          }
        }
        
        // 如果没找到下一个空屏幕，尝试从头找
        if (!nextScreenFound) {
          for (let i = 0; i < this.activeScreen - 1; i++) {
            if (!this.screenData[i]) {
              this.activeScreen = i + 1
              break
            }
          }
        }
      }
      this.selectedCamera = undefined
    }
  },
  watch: {
    viewMode: {
      handler(newMode) {
        console.log('View mode watcher triggered:', newMode)
        // 切换视图模式时，确保数据与新的屏幕数量匹配
        this.updateScreenData()
      }
    },
    visible(val) {
      // 当弹窗显示时，初始化数据
      if (val) {
        const screenCount = this.getScreenNumber
        this.screenData = new Array(screenCount).fill(null)
        this.activeScreen = 1
      }
    }
  },
  mounted() {
    // 初始化屏幕数据
    this.updateScreenData()
  }
}
</script>

<style scoped>
.cctv-container {
  background-color: #1e1e1e;
  border-radius: 4px;
  min-height: 600px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cctv-header {
  padding: 16px;
  background-color: #2a2a2a;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cctv-content {
  flex: 1;
  padding: 16px;
  display: grid;
  gap: 8px;
  height: calc(80vh - 120px);
}

.cctv-content.mode1x1 {
  grid-template-columns: 1fr;
}

.cctv-content.mode2x2 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.cctv-content.mode3x3 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.video-screen {
  background-color: #000;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.video-screen.active {
  border-color: #1890ff;
}

.video-info {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  display: flex;
  justify-content: space-between;
  z-index: 1;
}

.camera-status {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
}

.camera-status.online {
  background-color: #52c41a;
}

.camera-status.offline {
  background-color: #ff4d4f;
}

.video-placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #666;
}

.video-placeholder .anticon {
  font-size: 32px;
  margin-bottom: 8px;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 深度选择器语法在Vue2中 */
.cctv-container >>> .ant-modal-body {
  padding: 0;
}

.cctv-container >>> .ant-modal-header {
  background-color: #2a2a2a;
  border-bottom: 1px solid #1e1e1e;
}

.cctv-container >>> .ant-modal-title {
  color: #fff;
}

.cctv-container >>> .ant-modal-close {
  color: #fff;
}

.cctv-container >>> .ant-modal-content {
  background-color: #1e1e1e;
}

.mode-buttons {
  display: flex;
  gap: 8px;
}
</style>
